import { render, staticRenderFns } from "./UserAvatarCard.vue?vue&type=template&id=e951d852&scoped=true"
import script from "./UserAvatarCard.vue?vue&type=script&lang=js"
export * from "./UserAvatarCard.vue?vue&type=script&lang=js"
import style0 from "./UserAvatarCard.vue?vue&type=style&index=0&id=e951d852&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e951d852",
  null
  
)

export default component.exports